import { useEffect, useState } from 'react';
import styles from '../../components/contactUs/contactus.module.scss';
import { Accordion, AccordionDetails, AccordionSummary, Card, Grid, Typography } from '@mui/material';
import { CustomDownIcon, CustomUpIcon } from '../common/StyledComponents/StyledFields';

const HumanservicesFaqs = () => {
    const [isAccordionExpanded, setAccordionExpanded] = useState(false);
    const [isTempleOffered, setTempleOffered] = useState(false);
    const [isDevoteehelped, setDevoteeHelped] = useState(false);
    const [isDevoteedonate, setDevoteedonate] = useState(false);
    const [isvolunteerHelp, setVolunteerhelp] = useState(false);
    const [istalkaboutlivermore, settalkaboutLivermore] = useState(false);
    const [istalkaboutsupportstaff, settalsupportstaffView] = useState(false);
    const [ismanagementStructure, setmanagementStructure] = useState(false);
    const [isreligiousLivermore, setreligiouslivermore] = useState(false);
    const [isreligiousoffered, setreligiousoffered] = useState(false);
    const [isresidencereligious, setreligiosresidence] = useState(false);
    const [iskeyevents, setKeyevents] = useState(false);
    const [isservices, setservices] = useState(false);
    const [ispolicy, setpolicy] = useState(false);
    const [ispolicyview, setpolicyview] = useState(false);
    const handleAccordionChange = () => {
        setAccordionExpanded((prevExpanded) => !prevExpanded);
    };
    const handleTempleOfferedView = () => {
        setTempleOffered((prevExpanded) => !prevExpanded);
    }
    const handleDevoteehelpedView = () => {
        setDevoteeHelped((prevExpanded) => !prevExpanded);
    }
    const handleDevoteedonateView = () => {
        setDevoteedonate((prevExpanded) => !prevExpanded);
    }
    const handleVolunteerhelpView = () => {
        setVolunteerhelp((prevExpanded) => !prevExpanded);
    }
    const handletalkaboutlivermoreView = () => {
        settalkaboutLivermore((prevExpanded) => !prevExpanded);
    }
    const handletalkaboutsupportstaffView = () => {
        settalsupportstaffView((prevExpanded) => !prevExpanded);
    }
    const handlemanagementStructureView = () => {
        setmanagementStructure((prevExpanded) => !prevExpanded);
    }
    const handlereligiouslivermoreView = () => {
        setreligiouslivermore((prevExpanded) => !prevExpanded);
    }
    const handlereligiousofferedView = () => {
        setreligiousoffered((prevExpanded) => !prevExpanded);
    }
    const handlereligiosresidenceView = () => {
        setreligiosresidence((prevExpanded) => !prevExpanded);
    }
    const handlekeyeventsView = () => {
        setKeyevents((prevExpanded) => !prevExpanded);
    }
    const handlesevicesView = () => {
        setservices((prevExpanded) => !prevExpanded);
    }
    const handlepolicyView = () => {
        setpolicy((prevExpanded) => !prevExpanded);
    }
    const handlepolicyViewtwo = () => {
        setpolicyview((prevExpanded) => !prevExpanded);
    }
    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to the top of the page
        // Find the specific heading element by its ID or class name
        const faqcontent = document.getElementById('faqcontent');
        if (faqcontent) {
            faqcontent.scrollIntoView({ behavior: 'smooth' }); // Scroll to the heading
        }
    }, []);
    return (
        <>
            <div className={styles.faqtotalLayout}>
                <Typography className={styles.typoGraphyHeader}>
                    FAQ
                </Typography>
                <Card className={styles.cardContainer}>
                    <div className={styles.formFields}>
                        <Accordion
                            sx={{
                                border: isAccordionExpanded ? '1px solid #F05802' : '1px solid #989898',
                                background: '#FFECB4',
                                boxShadow: "none", borderRadius: "8px"
                            }}
                            expanded={isAccordionExpanded}
                            onChange={handleAccordionChange}
                        >
                            <AccordionSummary
                                aria-controls={`panel-content`}
                                id={`panel--header`}
                            >
                                <Grid container>
                                    <Grid item className={styles.iconstyles}>
                                        {isAccordionExpanded ? (
                                            <CustomUpIcon />
                                        ) : (
                                            <CustomDownIcon />
                                        )}
                                    </Grid>
                                    <Grid item>
                                        <Typography variant="subtitle1" className={styles.typoGraphyHeading}>What kind of services are provided?</Typography>
                                    </Grid>
                                </Grid>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Grid>
                                    <Typography className={styles.infomationtypo}>
                                        A. Basic health screening advisory services covering basic diagnostics such as blood pressure, heart beat, breathing check, visual inspection of ear, nose and throat and similar checks which does not require any kind of special equipment.
                                    </Typography>
                                </Grid>
                            </AccordionDetails>
                        </Accordion>
                        <Grid sx={{ marginTop: "16px" }}>
                            <Accordion
                                sx={{
                                    border: isTempleOffered ? '1px solid #F05802' : '1px solid #989898',
                                    background: '#FFECB4', boxShadow: "none", borderRadius: "8px"
                                }}
                                expanded={isTempleOffered}
                                onChange={handleTempleOfferedView}

                            >
                                <AccordionSummary
                                    aria-controls={`panel-content`}
                                    id={`panel--header`}
                                >
                                    <Grid container>
                                        <Grid item className={styles.iconstyles}>
                                            {isTempleOffered ? (
                                                <CustomUpIcon />
                                            ) : (
                                                <CustomDownIcon />
                                            )}
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="subtitle1" className={styles.typoGraphyHeading}>How about laboratory test?</Typography>
                                        </Grid>
                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Grid className={styles.content}>
                                        <div className={styles.listtext}>
                                            No laboratory tests will be conducted. The doctors will not draw blood at all.
                                        </div>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                        <Grid sx={{ marginTop: "16px" }}>
                            <Accordion
                                sx={{
                                    border: isDevoteehelped ? '1px solid #F05802' : '1px solid #989898',
                                    background: '#FFECB4',
                                    boxShadow: "none", borderRadius: "8px"
                                }}
                                expanded={isDevoteehelped}
                                onChange={handleDevoteehelpedView}
                            >
                                <AccordionSummary
                                    aria-controls={`panel-content`}
                                    id={`panel--header`}
                                >
                                    <Grid container>
                                        <Grid item className={styles.iconstyles}>
                                            {isDevoteehelped ? (
                                                <CustomUpIcon />
                                            ) : (
                                                <CustomDownIcon />
                                            )}
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="subtitle1" className={styles.typoGraphyHeading}>Can a visiting devotee receive treatment for an ailment or sickness?</Typography>
                                        </Grid>
                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails className={styles.content}>
                                    <Grid>
                                        <div className={styles.listtext}>
                                            No. the center is intended provide preventive health care and general health check
                                            ups only. The visitor must find his own medical aid channels for such services, if he desires.
                                        </div>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                        <Grid sx={{ marginTop: "16px" }}>
                            <Accordion
                                sx={{
                                    border: isDevoteedonate ? '1px solid #F05802' : '1px solid #989898',
                                    background: '#FFECB4',
                                    boxShadow: "none", borderRadius: "8px"
                                }}
                                expanded={isDevoteedonate}
                                onChange={handleDevoteedonateView}
                            >
                                <AccordionSummary
                                    aria-controls={`panel-content`}
                                    id={`panel--header`}
                                >
                                    <Grid container>
                                        <Grid item className={styles.iconstyles}>
                                            {isDevoteedonate ? (
                                                <CustomUpIcon />
                                            ) : (
                                                <CustomDownIcon />
                                            )}
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="subtitle1" className={styles.typoGraphyHeading}>Does the doctor prescribe drugs and distribute sample medicines?
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails className={styles.content}>
                                    <Grid>
                                        <div className={styles.text}>
                                            No. No prescriptions will be given. May advise those available over the counter only.
                                        </div>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        </Grid>

                        <Grid sx={{ marginTop: "16px" }}>
                            <Accordion
                                sx={{
                                    border: isvolunteerHelp ? '1px solid #F05802' : '1px solid #989898',
                                    background: '#FFECB4',
                                    boxShadow: "none", borderRadius: "8px"
                                }}
                                expanded={isvolunteerHelp}
                                onChange={handleVolunteerhelpView}
                            >
                                <AccordionSummary
                                    aria-controls={`panel-content`}
                                    id={`panel--header`}
                                >
                                    <Grid container>
                                        <Grid item className={styles.iconstyles}>
                                            {isvolunteerHelp ? (
                                                <CustomUpIcon />
                                            ) : (
                                                <CustomDownIcon />
                                            )}
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="subtitle1" className={styles.typoGraphyHeading}> Are the doctors licensed physicians?</Typography>
                                        </Grid>
                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails className={styles.content}>
                                    <Grid>
                                        <div className={styles.listtext}>
                                            All medical experts are California licensed physicians and are volunteering their time for this cause.
                                        </div>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        </Grid>

                        <Grid sx={{ marginTop: "16px" }}>
                            <Accordion
                                sx={{
                                    border: istalkaboutlivermore ? '1px solid #F05802' : '1px solid #989898',
                                    background: '#FFECB4',
                                    boxShadow: "none", borderRadius: "8px"
                                }}
                                expanded={istalkaboutlivermore}
                                onChange={handletalkaboutlivermoreView}
                            >
                                <AccordionSummary
                                    aria-controls={`panel-content`}
                                    id={`panel--header`}
                                >
                                    <Grid container>
                                        <Grid item className={styles.iconstyles}>
                                            {istalkaboutlivermore ? (
                                                <CustomUpIcon />
                                            ) : (
                                                <CustomDownIcon />
                                            )}
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="subtitle1" className={styles.typoGraphyHeading}>Would the individual be referred to any clinic or hospital?
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails className={styles.content}>
                                    <Grid>
                                        <div className={styles.listtext}>
                                            The visitors will be given the results and recommendations. The visitor is at liberty to do what he chooses to.
                                        </div>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                        <Grid sx={{ marginTop: "16px" }}>
                            <Accordion
                                sx={{
                                    border: istalkaboutsupportstaff ? '1px solid #F05802' : '1px solid #989898',
                                    background:'#FFECB4',
                                    boxShadow: "none", borderRadius: "8px"
                                }}
                                expanded={istalkaboutsupportstaff}
                                onChange={handletalkaboutsupportstaffView}
                            >
                                <AccordionSummary
                                    aria-controls={`panel-content`}
                                    id={`panel--header`}
                                >
                                    <Grid container>
                                        <Grid item className={styles.iconstyles}>
                                            {istalkaboutsupportstaff ? (
                                                <CustomUpIcon />
                                            ) : (
                                                <CustomDownIcon />
                                            )}
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="subtitle1" className={styles.typoGraphyHeading}>Any charges to be paid by the visiting devotee?</Typography>
                                        </Grid>
                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails className={styles.content}>
                                    <Grid>
                                        <ul className={styles.list}>
                                            <div className={styles.listtext}>
                                                None. It is a free service provided by Hindu Community and Cultural
                                                Center for the benefit of visiting devotees. No cost and no insurance requirements.
                                                However, the visitors are welcome to donate generously in cash and kind to run such charity services.
                                            </div>
                                        </ul>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                        <Grid sx={{ marginTop: "16px" }}>
                            <Accordion
                                sx={{
                                    border: ismanagementStructure ? '1px solid #F05802' : '1px solid #989898',
                                    background: '#FFECB4',
                                    boxShadow: "none", borderRadius: "8px"
                                }}
                                expanded={ismanagementStructure}
                                onChange={handlemanagementStructureView}
                            >
                                <AccordionSummary
                                    aria-controls={`panel-content`}
                                    id={`panel--header`}
                                >
                                    <Grid container>
                                        <Grid item className={styles.iconstyles}>
                                            {ismanagementStructure ? (
                                                <CustomUpIcon />
                                            ) : (
                                                <CustomDownIcon />
                                            )}
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="subtitle1" className={styles.typoGraphyHeading}>What is a consent form?</Typography>
                                        </Grid>
                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails className={styles.content}>
                                    <Grid>
                                        <Typography className={styles.listtext}>Every visitor must fill a consent form, sign and submit to the person in-charge authorizing the physician medical screening and examination. Such consent should be signed off after
                                            reading all items on the form and it is mandatory for any visitor.</Typography>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        </Grid>

                        <Grid sx={{ marginTop: "16px" }}>
                            <Accordion
                                sx={{
                                    border: isreligiousLivermore ? '1px solid #F05802' : '1px solid #989898',
                                    background: '#FFECB4',
                                    boxShadow: "none", borderRadius: "8px"
                                }}
                                expanded={isreligiousLivermore}
                                onChange={handlereligiouslivermoreView}
                            >
                                <AccordionSummary
                                    aria-controls={`panel-content`}
                                    id={`panel--header`}
                                >
                                    <Grid container>
                                        <Grid item className={styles.iconstyles}>
                                            {isreligiousLivermore ? (
                                                <CustomUpIcon />
                                            ) : (
                                                <CustomDownIcon />
                                            )}
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="subtitle1" className={styles.typoGraphyHeading}>What are the timings?</Typography>
                                        </Grid>
                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails className={styles.content}>
                                    <Grid>
                                        <Typography className={styles.listtext}>Every Saturday 12pm to 2pm </Typography>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        </Grid>

                        <Grid sx={{ marginTop: "16px" }}>
                            <Accordion
                                sx={{
                                    border: isreligiousoffered ? '1px solid #F05802' : '1px solid #989898',
                                    background: '#FFECB4',
                                    boxShadow: "none", borderRadius: "8px"
                                }}
                                expanded={isreligiousoffered}
                                onChange={handlereligiousofferedView}
                            >
                                <AccordionSummary
                                    aria-controls={`panel-content`}
                                    id={`panel--header`}
                                >
                                    <Grid container>
                                        <Grid item className={styles.iconstyles}>
                                            {isreligiousoffered ? (
                                                <CustomUpIcon />
                                            ) : (
                                                <CustomDownIcon />
                                            )}
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="subtitle1" className={styles.typoGraphyHeading}>Does this center also deal with temple medical emergencies?</Typography>
                                        </Grid>
                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails className={styles.content}>
                                    <Grid>
                                        <div className={styles.listtext}>
                                            It is not the objective of this center to deal with temple emergencies. However,
                                            if the attending physician is available, upon request
                                            he may choose to do first aid until 911 response arrives.
                                        </div>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        </Grid>

                        <Grid sx={{ marginTop: "16px" }}>
                            <Accordion
                                sx={{
                                    border: isresidencereligious ? '1px solid #F05802' : '1px solid #989898',
                                    background: '#FFECB4',
                                    boxShadow: "none", borderRadius: "8px"
                                }}
                                expanded={isresidencereligious}
                                onChange={handlereligiosresidenceView}
                            >
                                <AccordionSummary
                                    aria-controls={`panel-content`}
                                    id={`panel--header`}
                                >
                                    <Grid container>
                                        <Grid item className={styles.iconstyles}>
                                            {isresidencereligious ? (
                                                <CustomUpIcon />
                                            ) : (
                                                <CustomDownIcon />
                                            )}
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="subtitle1" className={styles.typoGraphyHeading}>Who can receive such services?</Typography>
                                        </Grid>
                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails className={styles.content}>
                                    <Grid>
                                        <Typography className={styles.listtext}>The services are meant for visiting devotees and their friends and relatives.
                                            However, the center is open to all independent of any restrictions.</Typography>
                                    </Grid>
                                </AccordionDetails>

                            </Accordion>
                        </Grid>

                        <Grid sx={{ marginTop: "16px" }}>
                            <Accordion
                                sx={{
                                    border: iskeyevents ? '1px solid #F05802' : '1px solid #989898',
                                    background: '#FFECB4',
                                    boxShadow: "none", borderRadius: "8px"
                                }}
                                expanded={iskeyevents}
                                onChange={handlekeyeventsView}
                            >
                                <AccordionSummary
                                    aria-controls={`panel-content`}
                                    id={`panel--header`}
                                >
                                    <Grid container>
                                        <Grid item className={styles.iconstyles}>
                                            {iskeyevents ? (
                                                <CustomUpIcon />
                                            ) : (
                                                <CustomDownIcon />
                                            )}
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="subtitle1" className={styles.typoGraphyHeading}>Is it required to take an appointment?
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails className={styles.content}>
                                    <Grid>
                                        <div className={styles.listtext}>
                                            No it is a walk-in health center. The visitors are expected to walk-in and fill a consent form and wait for their turn.
                                        </div>
                                    </Grid>
                                </AccordionDetails>

                            </Accordion>
                        </Grid>
                        <Grid>
                            <Typography className={styles.headertext}>DONATION IN KIND</Typography>
                        </Grid>
                        <Grid sx={{ marginTop: "16px" }}>
                            <Accordion
                                sx={{
                                    border: isservices ? '1px solid #F05802' : '1px solid #989898',
                                    background: '#FFECB4',
                                    boxShadow: "none", borderRadius: "8px"
                                }}
                                expanded={isservices}
                                onChange={handlesevicesView}
                            >
                                <AccordionSummary
                                    aria-controls={`panel-content`}
                                    id={`panel--header`}
                                >
                                    <Grid container>
                                        <Grid item className={styles.iconstyles}>
                                            {isservices ? (
                                                <CustomUpIcon />
                                            ) : (
                                                <CustomDownIcon />
                                            )}
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="subtitle1" className={styles.typoGraphyHeading}>What kind of donations are accepted in kind?</Typography>
                                        </Grid>
                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails className={styles.content}>
                                    <Grid>
                                        <div className={styles.listtext}>
                                            <Typography>At the present time we are accepting only clothing and toys and blankets all in GOOD
                                                condition only. Human Service volunteers will discard defective and excessively used items at the time of screening. Please help us by donating items in good condition.</Typography>
                                        </div>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        </Grid>

                        <Grid sx={{ marginTop: "16px" }}>
                            <Accordion
                                sx={{
                                    border: ispolicy ? '1px solid #F05802' : '1px solid #989898',
                                    background: '#FFECB4',
                                    boxShadow: "none", borderRadius: "8px"
                                }}
                                expanded={ispolicy}
                                onChange={handlepolicyView}
                            >
                                <AccordionSummary
                                    aria-controls={`panel-content`}
                                    id={`panel--header`}
                                >
                                    <Grid container>
                                        <Grid item className={styles.iconstyles}>
                                            {ispolicy ? (
                                                <CustomUpIcon />
                                            ) : (
                                                <CustomDownIcon />
                                            )}
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="subtitle1" className={styles.typoGraphyHeading}>Where can I bring them to donate?</Typography>
                                        </Grid>
                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails className={styles.content}>
                                    <Grid>
                                        <Typography className={styles.listtext}> We have placed a collection bin in the Assembly Hall
                                            at the entrance. Please drop them in the collection box.</Typography>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                        <Grid sx={{ marginTop: "16px" }}>
                            <Accordion
                                sx={{
                                    border: ispolicyview ? '1px solid #F05802' : '1px solid #989898',
                                    background: '#FFECB4',
                                    boxShadow: "none", borderRadius: "8px"
                                }}
                                expanded={ispolicyview}
                                onChange={handlepolicyViewtwo}
                            >
                                <AccordionSummary
                                    aria-controls={`panel-content`}
                                    id={`panel--header`}
                                >
                                    <Grid container>
                                        <Grid item className={styles.iconstyles}>
                                            {ispolicyview ? (
                                                <CustomUpIcon />
                                            ) : (
                                                <CustomDownIcon />
                                            )}
                                        </Grid>
                                        <Grid item>
                                            <Typography variant="subtitle1" className={styles.typoGraphyHeading}>Where do you distribute them?</Typography>
                                        </Grid>
                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails className={styles.content}>
                                    <Grid>
                                        <Typography className={styles.listtext}>Most of the women clothing such as sarees and some men's clothing and toys will be sent to any where in India for distribution to the needy people. The rest will be distributed locally to the needy people at shelter homes and through charity trusts. Such distribution is done to any needy person or organization independent of race, religion and regional discrimination.</Typography>
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        </Grid>
                    </div>
                </Card>
            </div >
        </>
    )
}
export default HumanservicesFaqs;
